import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root is missing from index.html');

/**
 * `StrictMode` is on deliberately.
 *
 * In development it double-invokes effects and renders, which surfaces missing
 * cleanup functions, unguarded subscriptions and effects that are not idempotent
 * — all of which are real bugs that would otherwise only appear as a leak or a
 * double request in production. The cost is a slightly noisy development
 * experience; the benefit is that the session-restore effect and every fetch
 * hook in this app were written to be safe under it.
 */
createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
